module.exports = __webpack_public_path__ + "4-o1.jpg?68ebe13148056347d19c6f156770aef8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/4-o1.jpg
// module id = 654
// module chunks = 0